import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@material-ui/core';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { DeviceListHead, DeviceListToolbar } from '../components/_dashboard/devices';
//
// import DEVICELIST from '../_mocks_/device';
import productTypeToName from '../utils/deviceNaming';

import apiHandler from '../api/axios-api';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'type', label: 'Type', alignRight: false },
  { id: 'summary', label: '', alignRight: false },
  // { id: 'group', label: 'Group', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  // { id: '' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.deviceName.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function DeviceSummary({ productType, data }) {
  let response = null;
  
  // console.log(data);

  if (data) {
    if (productType === 'TH_DOSER') {
      response = <>
        {'status' in data && <Label
          variant="filled"
          color="primary"
        >
          {data.status.temperature ? `${data.status.temperature} °C` : ''}
          {data.status.ec ? ` | ${Number.parseFloat(data.status.ec/1000).toFixed(1)} mS/cm` : ''}
          {data.status.ph ? ` | ${data.status.ph} pH` : ''}
        </Label>
        }
      </>;
    }
    if (productType === 'TH_NUTRIENT_SENSOR') {
      response = <>
        {'status' in data && <Label
          variant="filled"
          color="primary"
        >
          {data.status.temperature ? `${data.status.temperature} °C` : ''}
          {data.status.ec ? ` | ${Number.parseFloat(data.status.ec/1000).toFixed(1)} mS/cm` : ''}
          {data.status.ph ? ` | ${data.status.ph} pH` : ''}
        </Label>
        }
      </>;
    }
    if (productType === 'TH_AMBIENT') {
      response = <>
        {'status' in data && <Label
          variant="filled"
          color="primary"
        >
          {data.status.temperature ? `${data.status.temperature} °C` : ''}
          {data.status.humidity ? ` | ${data.status.humidity} %RH` : ''}
          {data.status.co2 ? ` | ${data.status.co2} ppm` : ''}
          {data.status.intensity ? ` | ${data.status.intensity} lux` : ''}
        </Label>
        }
      </>;
    }
  }
  return response;
}

export default function Device() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('deviceName');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    apiHandler("devices").then(
      res => setDevices(res.data.results)
    );
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = devices.map((n) => n.deviceName);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleDeviceClick = (event, deviceName) => {
    navigate(`/dashboard/devices/${deviceName}`);
  }

  const handleClick = (event, deviceName) => {
    const selectedIndex = selected.indexOf(deviceName);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, deviceName);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - devices.length) : 0;

  const filteredDevices = applySortFilter(devices, getComparator(order, orderBy), filterName);

  const isDeviceNotFound = filteredDevices.length === 0;

  return (
    <Page title="Devices | Agrio">
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Devices
          </Typography>
          {/* <Button
            variant="contained"
            component={RouterLink}
            to="#"
            startIcon={<Icon icon={plusFill} />}
          >
            New Device
          </Button> */}
        </Stack>

        <Card>
          <DeviceListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <DeviceListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={devices.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredDevices
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { deviceId, deviceName, productType, productVariant, online, data } = row;
                      const isItemSelected = selected.indexOf(deviceName) !== -1;

                      return (
                        <TableRow
                          hover
                          key={deviceId}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, deviceName)}
                            />
                          </TableCell>
                          <TableCell align="left" onClick={(event) => handleDeviceClick(event, deviceId)}>{deviceName}</TableCell>
                          <TableCell align="left" onClick={(event) => handleDeviceClick(event, deviceId)}>{productTypeToName(productType, productVariant)}</TableCell>
                          <TableCell align="left" onClick={(event) => handleDeviceClick(event, deviceId)}><DeviceSummary productType={productType} productVariant={productVariant} data={data} /></TableCell>
                          {/* <TableCell align="left" onClick={(event) => handleDeviceClick(event, deviceId)}>{groupId}</TableCell> */}
                          <TableCell align="left" onClick={(event) => handleDeviceClick(event, deviceId)}>
                            <Label
                              variant="ghost"
                              color={(online === false && 'error') || 'success'}
                            >
                              {sentenceCase(online ? "online" : "offline")}
                            </Label>
                          </TableCell>

                          {/* <TableCell align="right">
                            <DeviceMoreMenu />
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isDeviceNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={devices.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page >
  );
}
